export const BLOCK_MAP_STATE = {
  lessonPlans: [],
  blockMaps: [],
};
